import React from "react"
import { Flex } from "@chakra-ui/react"
import { getCardinalDirection } from "../utils/helpers"
import { ArrowUpIcon } from "@chakra-ui/icons"

export const CardinalDirectionIndicator = (props) => {
    const { degrees, directionSize, arrowSize, isMapView, parameter } = props

    if (Number.isNaN(degrees)) {
        return null
    }

    // degrees is meteorological "from" direction
    // convert to "to" direction for arrow rotation
    const rotation = parameter?.includes("wind") ? (degrees + 180) % 360 : degrees;

    return (
        <Flex marginLeft={isMapView ? 0 : 2} direction={isMapView ? 'column' : 'row'} alignItems={'center'}>
            <strong style={{ fontSize: directionSize, marginBottom: isMapView ? '-5px' : '' }}>{getCardinalDirection(degrees)}</strong>
            <ArrowUpIcon style={{ transform: `rotate(${rotation}deg)`, color: '#E53E3E', fontSize: arrowSize }} />
        </Flex>
    )
}